// extracted by mini-css-extract-plugin
export default {"BtnText":"BtnText_BtnText__O-r0F"};